import { Link } from "react-router-dom";
import { MapPin, Clock, ImageOff } from "lucide-react";
import { imgUrl, formatPrice, timeAgo } from "../../lib/api";
import { PROPERTY_TYPES, formatArea } from "../../lib/categories";
import { DirectOwnerBadge } from "./PropertyHighlight";
import SoldStamp from "./SoldStamp";

export default function AdCard({ ad, row = false }) {
  const src = imgUrl(ad.photos?.[0]);
  const place = [ad.place, ad.taluka && ad.taluka !== ad.place ? ad.taluka : null, ad.location].filter(Boolean).slice(0, 2).join(", ");
  return (
    <Link
      to={`/ad/${ad.id}`}
      className={`group bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-0.5 hover:border-[var(--orange)] transition-[transform,box-shadow,border-color] duration-200 ${row ? "flex" : "flex flex-col"}`}
      data-testid={`ad-card-${ad.id}`}
    >
      <div className={`relative overflow-hidden bg-slate-100 shrink-0 ${row ? "w-36 sm:w-56 aspect-[4/3]" : "aspect-[4/3]"}`}>
        {src ? (
          <img src={src} alt={ad.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400"><ImageOff className="w-8 h-8" /></div>
        )}
        <span className="absolute top-2 left-2 text-[11px] font-semibold bg-white/90 text-[var(--navy)] px-2 py-0.5 rounded-full">{ad.category}</span>
        {ad.condition && <span className={`absolute top-2 right-2 text-[11px] font-bold text-white px-2 py-0.5 rounded-full ${ad.condition === "old" ? "bg-[var(--orange)]" : "bg-[var(--buy)]"}`} data-testid="ad-card-condition">{ad.condition === "old" ? "जुना" : "नवीन"}</span>}
        {ad.category === "Property" && ad.direct_owner && !ad.sold && <span className="absolute bottom-2 left-2"><DirectOwnerBadge /></span>}
        {ad.sold && <SoldStamp />}
      </div>
      <div className="p-3 sm:p-4 flex flex-col gap-1 min-w-0 flex-1">
        <p className={`font-display font-extrabold text-lg sm:text-xl ${ad.sold ? "text-slate-400 line-through" : "text-[var(--navy)]"}`} data-testid="ad-card-price">{formatPrice(ad.price)}</p>
        <p className="text-sm sm:text-base text-slate-700 line-clamp-2 leading-snug" data-testid="ad-card-title">{ad.title}</p>
        {ad.category === "Property" && ad.property_type && (
          <p className="text-xs font-semibold text-green-700" data-testid="ad-card-property-info">{PROPERTY_TYPES[ad.property_type]?.mr}{formatArea(ad) ? ` · ${formatArea(ad)}` : ""}{ad.has_712 ? " · 7/12 ✓" : ""}</p>
        )}
        <div className="mt-auto pt-2 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-xs text-slate-500">
          <span className="flex items-center gap-1 min-w-0"><MapPin className="w-3.5 h-3.5 shrink-0" /> <span className="truncate">{place}</span></span>
          <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {timeAgo(ad.created_at)}</span>
        </div>
      </div>
    </Link>
  );
}

export function AdSkeleton() {
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden animate-pulse">
      <div className="aspect-[4/3] bg-slate-200" />
      <div className="p-4 space-y-2"><div className="h-5 w-1/2 bg-slate-200 rounded" /><div className="h-4 w-full bg-slate-100 rounded" /></div>
    </div>
  );
}
